import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

export default class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentWillUnmount() {
    if (document.body)
      document.body.removeEventListener("click", this.close, true);
  }

  open = (evt) => {
    this.setState({ isOpen: true });
    evt.stopPropagation();
    document.body.addEventListener("click", this.close, true);
  };

  close = (evt) => {
    let node = evt.target;
    while (node.parentNode && node !== this.contentNode) {
      node = node.parentNode;
    }
    if (node !== this.contentNode) {
      this.setState({ isOpen: false });
      evt.stopPropagation();
      document.body.removeEventListener("click", this.close, true);
    }
  };

  render() {
    const {
      activeClassName,
      className,
      disabled,
      style,
      dropdownClassName,
      overlay,
      children,
    } = this.props;
    const { isOpen } = this.state;
    return (
      <div
        className={`caret ${styles.container} ${
          isOpen ? `${styles.open} ${activeClassName || ""}` : ""
        } ${className || ""} ${disabled ? styles.disabled : ""}`}
        style={style}
        role="menu"
        tabIndex={0}
        onClick={this.open}
        onKeyDown={() => {}}
        data-qa="dropdown"
      >
        {children}
        {isOpen && (
          <div
            className={`${styles.dropdown} ${dropdownClassName || ""}`}
            ref={(ref) => {
              this.contentNode = ref;
            }}
          >
            {overlay}
          </div>
        )}
      </div>
    );
  }
}

Dropdown.propTypes = {
  disabled: PropTypes.bool,
  activeClassName: PropTypes.string,
  dropdownClassName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  overlay: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

Dropdown.defaultProps = {
  disabled: false,
  activeClassName: null,
  dropdownClassName: null,
  className: null,
  style: null,
};
